module.exports = __webpack_public_path__ + "iPad_Air_2_icon.svg?99fcfcaf27fdb075eccd1465559bbfd8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/iPad_Air_2_icon.svg
// module id = 220
// module chunks = 0